import { useState } from "react";
import { CampoNumero, Pestanas, Resultado, Dato, Rejilla, mxn } from "../components/campos.jsx";
import { aplicarDescuentos, precioUnitario } from "../lib/calc.js";

export default function Descuentos() {
  const [modo, setModo] = useState("descuentos");

  return (
    <div className="space-y-6">
      <Pestanas
        valor={modo}
        onChange={setModo}
        opciones={[
          { valor: "descuentos", etiqueta: "Calcular descuentos" },
          { valor: "unitario", etiqueta: "Comparador precio unitario" },
        ]}
      />
      {modo === "descuentos" ? <PanelDescuentos /> : <PanelUnitario />}
    </div>
  );
}

function PanelDescuentos() {
  const [precio, setPrecio] = useState(1000);
  const [d1, setD1] = useState(20);
  const [d2, setD2] = useState(10);

  const r = aplicarDescuentos(precio, [d1, d2]);

  return (
    <Rejilla>
      <div className="space-y-4">
        <CampoNumero label="Precio original" valor={precio} onChange={setPrecio} prefijo="$" min={0} />
        <CampoNumero label="Primer descuento" valor={d1} onChange={setD1} sufijo="%" min={0} max={100} />
        <CampoNumero
          label="Segundo descuento"
          valor={d2}
          onChange={setD2}
          sufijo="%"
          min={0}
          max={100}
          ayuda="Ejemplo: descuento de tarjeta sobre la rebaja."
        />
      </div>

      <div className="order-first space-y-3 lg:order-last lg:col-span-2">
        <Resultado label="Precio final" valor={mxn(r.precioFinal)} tono="positivo" nota={`Ahorras ${mxn(r.ahorro)}`} />
        <div className="tarjeta">
          <Dato label="Precio original" valor={mxn(r.precioOriginal)} />
          {r.pasos.map((p, i) => (
            <Dato key={i} label={`Descuento ${i + 1} (${p.pct}%)`} valor={`− ${mxn(p.rebaja)}`} />
          ))}
          <Dato label="Precio final" valor={mxn(r.precioFinal)} destacar />
          <Dato label="Descuento efectivo real" valor={`${r.descuentoEfectivoPct.toFixed(2)}%`} />
        </div>

        {r.pasos.length > 1 && (
          <p className="rounded-xl border border-[color:var(--aviso-borde)] bg-[color:var(--aviso-bg)] p-3 text-2xs text-[color:var(--aviso)]">
            Ojo: {d1}% + {d2}% no es {d1 + d2}%. El segundo descuento se aplica sobre el precio ya
            rebajado, así que el descuento real es {r.descuentoEfectivoPct.toFixed(2)}%.
          </p>
        )}
      </div>
    </Rejilla>
  );
}

function PanelUnitario() {
  const [a, setA] = useState({ precio: 45, cantidad: 1.5 });
  const [b, setB] = useState({ precio: 78, cantidad: 3 });

  const ua = precioUnitario(a.precio, a.cantidad);
  const ub = precioUnitario(b.precio, b.cantidad);
  const ganaA = ua > 0 && ub > 0 ? ua < ub : null;

  return (
    <Rejilla cols="lg:grid-cols-2">
      {[
        { nombre: "Opción A", v: a, set: setA, unitario: ua, gana: ganaA === true },
        { nombre: "Opción B", v: b, set: setB, unitario: ub, gana: ganaA === false },
      ].map((o) => (
        <div key={o.nombre} className={`tarjeta space-y-4 ${o.gana ? "border-[color:var(--positivo-borde)]" : ""}`}>
          <h3 className="flex items-center justify-between font-bold text-[color:var(--texto)]">
            {o.nombre}
            {o.gana && (
              <span className="rounded-full bg-[color:var(--positivo-bg)] px-2 py-0.5 text-2xs font-semibold text-[color:var(--positivo)]">
                Más conveniente
              </span>
            )}
          </h3>
          <CampoNumero label="Precio" valor={o.v.precio} onChange={(x) => o.set({ ...o.v, precio: x })} prefijo="$" min={0} />
          <CampoNumero
            label="Contenido / cantidad"
            valor={o.v.cantidad}
            onChange={(x) => o.set({ ...o.v, cantidad: x })}
            min={0}
            ayuda="Usa la misma unidad en ambas opciones (kg, L, piezas…)."
          />
          <Dato label="Precio por unidad" valor={mxn(o.unitario)} destacar />
        </div>
      ))}

      {ganaA !== null && (
        <p className="text-2xs texto-3 lg:col-span-2">
          La opción {ganaA ? "A" : "B"} cuesta {mxn(Math.abs(ua - ub))} menos por unidad
          {ua && ub ? ` (${(((Math.max(ua, ub) - Math.min(ua, ub)) / Math.max(ua, ub)) * 100).toFixed(1)}% de diferencia)` : ""}.
        </p>
      )}
    </Rejilla>
  );
}
